import { useViewportSizeInPixels } from './use-viewport-size-in-pixels'

// These breakpoints are based on the tailwind breakpoints (min-width)
export const DEVICE_TYPE_BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
}

export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const

export const useDeviceType = () => {
  const { width } = useViewportSizeInPixels()

  if (width <= DEVICE_TYPE_BREAKPOINTS.MOBILE) {
    return DEVICE_TYPE.MOBILE
  } else if (width < DEVICE_TYPE_BREAKPOINTS.DESKTOP) {
    return DEVICE_TYPE.TABLET
  } else {
    return DEVICE_TYPE.DESKTOP
  }
}
